import * as categories from 'src/api/categories'
// import router from 'src/router'
import {
  GET_ALL_CATEGORIES,
  SET_CATEGORY,
  CATEGORY_HELPERS,
  SET_CATEGORIES
} from 'src/store/mutation-types'

const getAllCategories = ({commit, dispatch}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  categories.getAllCategories(params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_CATEGORIES, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_CATEGORIES, [])
    }
  })
}

// const getRegion = ({commit, dispatch}, configs) => {
//   dispatch('toggleLoadding', true, {root: true})
//   regions.getRegion(configs).then(response => {
//     switch (response.code) {
//       case 200:
//         dispatch('toggleLoadding', false, {root: true})
//         commit(GET_REGION, response.data)
//         break
//       case 404:
//         dispatch('toggleLoadding', false, {root: true})
//         dispatch('showNotify', {
//           title: 'Không tìm thấy tài nguyên',
//           body: 'Vùng miền không tồn tại trên hệ thống',
//           type: 'warning'
//         }, {root: true})
//         router.push({name: 'region'})
//         break
//       default:
//         dispatch('toggleLoadding', false, {root: true})
//     }
//   })
// }
const setCategory = ({commit}, data) => {
  commit(SET_CATEGORY, data)
}

const getCategoryHelpers = ({commit}) => {
  categories.getCategoryHelpers().then(response => {
    commit(CATEGORY_HELPERS, response)
  })
}

const setCategories = ({commit}, data) => {
  commit(SET_CATEGORIES, data)
}

const getToTreeCategory = ({commit, dispatch}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  categories.getToTreeCategory(params).then(response => {
    dispatch('toggleLoadding', false, {root: true})
    commit(GET_ALL_CATEGORIES, response)
  })
}

export default{
  getAllCategories,
  setCategory,
  getCategoryHelpers,
  setCategories,
  getToTreeCategory
}



// WEBPACK FOOTER //
// ./src/components/category/store/actions.js